import * as React from "react";

interface Props {}

export const RejectedSvg = (props: Props) => (
	<svg
		width={16}
		height={16}
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<circle cx={8} cy={8} r={8} fill="white" />
		<rect
			x={10.4044}
			y={5}
			width={1.5286}
			height={7.64298}
			rx={0.764298}
			transform="rotate(45 10.4044 5)"
			fill="#FF2727"
		/>
		<rect
			x={5.00012}
			y={6.08105}
			width={1.5286}
			height={7.64298}
			rx={0.764298}
			transform="rotate(-45 5.00012 6.08105)"
			fill="#FF2727"
		/>
	</svg>
);
